import { Component } from '@angular/core';

@Component({
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss']
})
export class AuthComponent {
}



// WEBPACK FOOTER //
// /code/frontend/src/app/auth/auth.component.ts